/* eslint-disable import/prefer-default-export */
import { get } from './http';

const baseUrl = '/api/pilot-view';

// cockpits
export function getCockpit({ cockpitVersionId, uavModelId }) {
  return get(`${baseUrl}/cockpit/${cockpitVersionId}/uav/${uavModelId}`);
}
